export default __webpack_public_path__ + "static/media/line-dark.2c163514.svg";